import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/lib/auth';
import { GoogleLoginButton } from '@/pages/Login';

export default function Signup() {
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error('Wachtwoord moet minimaal 8 tekens zijn');
      return;
    }
    setBusy(true);
    try {
      await signup(email, password);
      toast.success('Account aangemaakt — check je inbox om je e-mail te bevestigen.');
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Registratie mislukt');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Account maken</CardTitle>
          <CardDescription>Start je eerste launch in minuten.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Wachtwoord</Label>
              <Input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
              <p className="text-xs text-muted-foreground">Minimaal 8 tekens.</p>
            </div>
            <Button type="submit" disabled={busy} className="w-full">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Account aanmaken
            </Button>
            <div className="flex items-center gap-3">
              <div className="h-px flex-1 bg-border" />
              <span className="text-xs text-muted-foreground">of</span>
              <div className="h-px flex-1 bg-border" />
            </div>
            <GoogleLoginButton label="Registreren met Google" />
            <p className="text-sm text-muted-foreground text-center">
              Al een account?{' '}
              <Link to="/login" className="text-primary hover:underline">Log in</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
